import PropTypes from 'prop-types';
import get from 'lodash/get';
import take from 'lodash/take';

import {getSessionStatus} from '../../helpers/sessions';

import DownloadInvoiceButton from './DownloadInvoiceButton';
import DownloadNoteButton from './DownloadNoteButton';
import EditNoteButton from './EditNoteButton';
import EditSessionButton from './EditSessionButton';
import SchedulePatientButton from '../patients/SchedulePatientButton';
import MessageUserButton from '../messages/MessageUserButton';
import ViewProviderButton from '../providers/ViewProviderButton';

const getButtons = props => {
  const {variant, variantText, session, isPatient, limit = 2, onSave = null, classButtonText, size} = props;
  const s = session;
  const status = getSessionStatus(s);
  let childProps;
  const defaultChildProps = {
    session,
    isPatient,
    patient: get(session, 'patient') || null,
    size: size ?? 'medium',
    classButtonText,
    variant: 'outlined',
    variantText: variantText || 'small600',
    iconOnly: props.iconOnly || false,
    // textProps: {
      // variant: 'small600'
    // }
  }
  switch(variant) {
    case 'icon':
      childProps = {
        ...defaultChildProps,
        iconOnly: true,
        fullWidth: false,
      };
      break;
    case 'card':
      childProps = {
        ...defaultChildProps,
        fullWidth: true,
        textOnly: true,
      };
      break;
    default:
      childProps = {
        ...defaultChildProps,
      };
  }
  let buttons = [];
  if (!isPatient) {
    if (['Completed'].includes(status)) {
      buttons.push(<DownloadInvoiceButton {...childProps} />);
      buttons.push(<DownloadNoteButton {...childProps} />);
    }
    if (['Canceled'].includes(status)) {
      buttons.push(<SchedulePatientButton {...childProps} />);
      buttons.push(<MessageUserButton {...childProps} provider={s.provider} />);
    }
    if (status === 'Incomplete') {
      buttons.push(<EditNoteButton {...childProps} />);
      buttons.push(<SchedulePatientButton {...childProps} onSave={onSave}/>);
    }
    if (status === 'Upcoming') {
      buttons.push(<EditSessionButton {...childProps} onSubmitted={onSave} />);
      buttons.push(<MessageUserButton {...childProps} provider={s.provider} />);
    }
  } else {
    if (['Completed'].includes(status)) {
      buttons.push(<DownloadInvoiceButton {...childProps} />);
      buttons.push(<DownloadNoteButton {...childProps} />);
    }
    if (['Canceled'].includes(status)) {
      // Send Message, View Provider Profile, Download Receipt, Download Note, Leave a Review
      buttons.push(<MessageUserButton {...childProps} provider={s.provider} />);
      buttons.push(<ViewProviderButton {...childProps} provider={s.provider} />);
    }
    if (status === 'Incomplete') { // Send Message, View Provider Profile
      buttons.push(<MessageUserButton {...childProps} provider={s.provider} />);
      buttons.push(<ViewProviderButton {...childProps} provider={s.provider} />);
    }
    if (status === 'Upcoming') { // Send Message, View Provider Profile, Edit Session, Cancel Session
      buttons.push(<MessageUserButton {...childProps} provider={s.provider} />);
      buttons.push(<ViewProviderButton {...childProps} provider={s.provider} />);
    }
  }
  return take(buttons, limit);
};

const SessionActions = props => {
  return getButtons(props);
};

SessionActions.defaultProps = {
  variant: 'text',
  isPatient: false,
  limit: 2,
};

SessionActions.propTypes = {
  session: PropTypes.object,
  variant: PropTypes.string,
  isPatient: PropTypes.boolean,
  limit: PropTypes.number,
};

export default SessionActions;
